module.exports = __webpack_public_path__ + "img/1490407262.472b3ec2.jpg";